var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrwsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 70,
    viewBox: "0 0 232 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.2098V0L13.4831 29.7751L0 69.2098Z",
    fill: "#E8B500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22.7527L13.4831 29.7751L0 0Z",
    fill: "#FFD94A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7525 0V25.506L13.4829 29.7751L22.7525 0Z",
    fill: "#E8B500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.2098H22.7527L13.4831 29.7751L0 69.2098Z",
    fill: "#B77A00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7525 69.2098V43.4253L13.4829 29.7751L22.7525 69.2098Z",
    fill: "#FFD94A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7525 43.4253H47.9365L13.4829 29.7751L22.7525 43.4253Z",
    fill: "#B77A00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7525 25.5061H44.4543L44.0063 32.8821L30.8622 36.6597L13.4829 29.7753L22.7525 25.5061Z",
    fill: "#FFD94A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.936 43.4253L44.0059 32.882L30.8618 36.6595L47.936 43.4253Z",
    fill: "#E8B500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0059 32.8821L51.0356 31.6568L44.4538 25.5061L44.0059 32.8821Z",
    fill: "#E8B500"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.936 43.4254L51.0356 31.6567L44.0059 32.882L47.936 43.4254Z",
    fill: "#B77A00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4541 25.5059V0.263916L51.0358 31.6566L44.4541 25.5059Z",
    fill: "#E8B500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4541 0.263916H64.5649L51.0358 31.6566L44.4541 0.263916Z",
    fill: "#FFD94A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4541 43.4253H47.9363L44.4541 69.2097V43.4253Z",
    fill: "#E8B500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4541 69.2098H64.5649L51.0358 31.6567L47.9363 43.4254L44.4541 69.2098Z",
    fill: "#FFD94A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5652 0.263916V69.2097L51.0361 31.6566L64.5652 0.263916Z",
    fill: "#E8B500"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5649 0.263916H105.106L85.8381 12.4709L64.5649 0.263916Z",
    fill: "#FFD94A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5649 0.263916V31.9666L77.4669 15.9603L64.5649 0.263916Z",
    fill: "#FFD94A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4669 15.9603L85.8381 12.4709L64.5649 0.263916L77.4669 15.9603Z",
    fill: "#E8B500"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M77.4669 15.9603L85.8381 12.4709L64.5649 0.263916L77.4669 15.9603Z",
    fill: "url(#paint0_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8957 17.6408L85.838 12.4708L77.4668 15.9602L80.8957 17.6408Z",
    fill: "#FFD94A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.896 17.6408H93.9287L85.8383 12.4708L80.896 17.6408Z",
    fill: "#B77A00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9287 17.6408H99.9196L85.8384 12.4708L93.9287 17.6408Z",
    fill: "#FFD94A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.106 0.263916L99.9196 17.6408L85.8384 12.4709L105.106 0.263916Z",
    fill: "#E8B500"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8877 17.6408H120.471L105.106 0.263916L99.8877 17.6408Z",
    fill: "#FFD94A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.471 17.6409V32.7343L108.01 35.0928L120.471 17.6409Z",
    fill: "#FFD94A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.01 35.0928L99.8877 17.6409H120.471L108.01 35.0928Z",
    fill: "#E8B500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8876 23.409V17.6409H93.9282L99.8876 23.409Z",
    fill: "#E8B500"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.01 35.0928L99.8877 29.2691V17.6409L108.01 35.0928Z",
    fill: "#B77A00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M108.01 35.0929H94.3765L99.8879 29.2692L108.01 35.0929Z",
    fill: "#E8B500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.941 41.2339L108.01 35.0929H94.3765L101.941 41.2339Z",
    fill: "#FFD94A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M120.47 32.7343L101.941 41.2338L108.009 35.0928L120.47 32.7343Z",
    fill: "#B77A00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.682 47.152L120.47 32.7343L101.941 41.2338L108.682 47.152Z",
    fill: "#E8B500"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3767 35.0929H80.896L101.942 41.2339L94.3767 35.0929Z",
    fill: "#B77A00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M101.941 41.2338L95.2021 56.6274L108.683 47.152L101.941 41.2338Z",
    fill: "#FFD94A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5649 69.2099L80.8957 46.1036V69.2099H64.5649Z",
    fill: "#FFD94A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99.883 69.2097H127.072L95.2021 56.6274L99.883 69.2097Z",
    fill: "#E8B500"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M109.395 48.3871L108.683 47.1521L95.2021 56.6275L109.395 48.3871Z",
    fill: "#E8B500"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M127.072 69.2097L109.395 48.387L95.2021 56.6274L127.072 69.2097Z",
    fill: "#FFD94A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8832 69.2099L80.896 46.1036L95.2024 56.6276L99.8832 69.2099Z",
    fill: "#B77A00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.896 35.0929L87.0733 44.0065L80.896 46.1036V35.0929Z",
    fill: "#FFD94A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M101.942 41.2339L87.0733 44.0065L80.896 35.0929L101.942 41.2339Z",
    fill: "#E8B500"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2024 56.6276L101.942 41.2339L87.0733 44.0065L80.896 46.1036L95.2024 56.6276Z",
    fill: "#FFD94A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4668 15.9603L80.8957 21.6098V17.6409L77.4668 15.9603Z",
    fill: "#B77A00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8957 35.0928V21.6098L77.4669 15.9603L64.5649 31.9666V69.2098L80.8957 46.1035V35.0928Z",
    fill: "#E8B500"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M77.4669 15.9603L85.8381 12.4709L64.5649 0.263916L77.4669 15.9603Z",
    fill: "url(#paint1_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M101.941 41.2339L108.01 35.0929H94.3765L101.941 41.2339Z",
    fill: "url(#paint2_linear_1681_235)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.2098V0L13.4831 29.7751L0 69.2098Z",
    fill: "#E8B500"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.5679 0.263916V31.9642L77.4698 15.9603L64.5679 0.263916Z",
    fill: "url(#paint3_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M77.4669 15.9603L85.8381 12.4709L64.5649 0.263916L77.4669 15.9603Z",
    fill: "url(#paint4_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.5649 69.2099L80.8957 46.1036V69.2099H64.5649Z",
    fill: "url(#paint5_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M80.8957 17.6408L85.838 12.4708L77.4668 15.9602L80.8957 17.6408Z",
    fill: "url(#paint6_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M80.896 17.6408H93.9287L85.8383 12.4708L80.896 17.6408Z",
    fill: "url(#paint7_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M93.9287 17.6408H99.9196L85.8384 12.4708L93.9287 17.6408Z",
    fill: "url(#paint8_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M105.106 0.263916L99.9196 17.6408L85.8384 12.4709L105.106 0.263916Z",
    fill: "url(#paint9_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M99.8877 17.6408H120.471L105.106 0.263916L99.8877 17.6408Z",
    fill: "url(#paint10_linear_1681_235)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M120.471 17.6409V32.7343L108.01 35.0928L120.471 17.6409Z",
    fill: "url(#paint11_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M108.01 35.0928L99.8877 17.6409H120.471L108.01 35.0928Z",
    fill: "url(#paint12_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M99.8876 23.409V17.6409H93.9282L99.8876 23.409Z",
    fill: "url(#paint13_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M108.01 35.0928L99.8877 29.2691V17.6409L108.01 35.0928Z",
    fill: "url(#paint14_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M108.01 35.0929H94.3765L99.8879 29.2692L108.01 35.0929Z",
    fill: "url(#paint15_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M120.47 32.7343L101.941 41.2338L108.009 35.0928L120.47 32.7343Z",
    fill: "url(#paint16_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M108.682 47.152L120.47 32.7343L101.941 41.2338L108.682 47.152Z",
    fill: "url(#paint17_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M94.3767 35.0929H80.896L101.942 41.2339L94.3767 35.0929Z",
    fill: "url(#paint18_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M101.941 41.2338L95.2021 56.6274L108.683 47.152L101.941 41.2338Z",
    fill: "url(#paint19_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M99.883 69.2097H127.072L95.2021 56.6274L99.883 69.2097Z",
    fill: "url(#paint20_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M109.395 48.3871L108.683 47.1521L95.2021 56.6275L109.395 48.3871Z",
    fill: "url(#paint21_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M127.072 69.2097L109.395 48.387L95.2021 56.6274L127.072 69.2097Z",
    fill: "url(#paint22_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M99.8832 69.2099L80.896 46.1036L95.2024 56.6276L99.8832 69.2099Z",
    fill: "url(#paint23_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M80.896 35.0929L87.0733 44.0065L80.896 46.1036V35.0929Z",
    fill: "url(#paint24_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M101.942 41.2339L87.0733 44.0065L80.896 35.0929L101.942 41.2339Z",
    fill: "url(#paint25_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M95.2024 56.6276L101.942 41.2339L87.0733 44.0065L80.896 46.1036L95.2024 56.6276Z",
    fill: "url(#paint26_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M77.4668 15.9603L80.8957 21.6098V17.6409L77.4668 15.9603Z",
    fill: "url(#paint27_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M80.8957 35.0928V21.6098L77.4669 15.9603L64.5649 31.9642V69.2098L80.8957 46.1035V35.0928Z",
    fill: "url(#paint28_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.5649 0.263916H105.106L85.8381 12.4709L64.5649 0.263916Z",
    fill: "url(#paint29_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0 69.2001V0L13.4831 29.7751L0 69.2001Z",
    fill: "url(#paint30_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M0 0H22.7527L13.4831 29.7751L0 0Z",
    fill: "url(#paint31_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.7525 0V25.506L13.4829 29.7751L22.7525 0Z",
    fill: "url(#paint32_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M0 69.2001H22.7527L13.4831 29.7751L0 69.2001Z",
    fill: "url(#paint33_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.7525 69.2001V43.4253L13.4829 29.7751L22.7525 69.2001Z",
    fill: "url(#paint34_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.7525 43.4253H47.9365L13.4829 29.7751L22.7525 43.4253Z",
    fill: "url(#paint35_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.7525 25.5061H44.4543L44.0063 32.8821L30.8622 36.6597L13.4829 29.7753L22.7525 25.5061Z",
    fill: "url(#paint36_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M47.936 43.4253L44.0059 32.882L30.8618 36.6595L47.936 43.4253Z",
    fill: "url(#paint37_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M44.0059 32.8821L51.0356 31.6568L44.4538 25.5061L44.0059 32.8821Z",
    fill: "url(#paint38_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M47.936 43.4254L51.0356 31.6567L44.0059 32.882L47.936 43.4254Z",
    fill: "url(#paint39_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M44.4541 25.5059V0.263916L51.0358 31.6566L44.4541 25.5059Z",
    fill: "url(#paint40_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M44.4541 0.263916H64.5649L51.0358 31.6566L44.4541 0.263916Z",
    fill: "url(#paint41_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M44.4541 43.4253H47.9363L44.4541 69.2097V43.4253Z",
    fill: "url(#paint42_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M44.4541 69.2098H64.5649L51.0358 31.6567L47.9363 43.4254L44.4541 69.2098Z",
    fill: "url(#paint43_linear_1681_235)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.5652 0.263916V69.2097L51.0361 31.6566L64.5652 0.263916Z",
    fill: "url(#paint44_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M78.0504 0.263916H64.5649V69.2097H78.0504V0.263916Z",
    fill: "url(#paint45_linear_1681_235)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M183.639 69.0449C181.563 69.0449 179.906 68.4252 178.666 67.1857C177.334 65.8533 176.667 63.8082 176.667 61.0504C176.667 58.4011 177.31 56.2553 178.596 54.613C179.898 52.9552 181.772 52.1263 184.22 52.1263C186.235 52.1263 188.039 52.7228 189.635 53.9158L187.52 57.0997C186.42 56.2785 185.344 55.868 184.29 55.868C183.376 55.868 182.663 56.1778 182.152 56.7975C181.641 57.4173 181.331 58.2617 181.222 59.3307C182.323 58.4941 183.492 58.0757 184.732 58.0757C186.235 58.0757 187.505 58.5328 188.543 59.4469C189.581 60.361 190.1 61.6082 190.1 63.1885C190.1 64.9702 189.48 66.3956 188.241 67.4646C187.001 68.5182 185.468 69.0449 183.639 69.0449ZM181.78 64.9315C182.199 65.3343 182.756 65.5357 183.454 65.5357C184.151 65.5357 184.701 65.3421 185.104 64.9547C185.506 64.5519 185.708 64.0329 185.708 63.3977C185.708 62.8089 185.499 62.3131 185.08 61.9103C184.662 61.5075 184.104 61.3061 183.407 61.3061C182.71 61.3061 182.16 61.5075 181.757 61.9103C181.354 62.2976 181.153 62.8012 181.153 63.4209C181.153 64.0251 181.362 64.5287 181.78 64.9315Z",
    fill: "#E7B400"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M161.979 68.7197V65.3267L168.068 60.6787C168.827 60.1055 169.362 59.602 169.672 59.1682C169.997 58.7189 170.16 58.2463 170.16 57.7505C170.16 57.2393 169.989 56.8364 169.649 56.5421C169.323 56.2477 168.889 56.1005 168.347 56.1005C167.82 56.1005 167.309 56.2632 166.813 56.5885C166.333 56.8984 165.768 57.4329 165.117 58.1921L162.072 55.6589C163.002 54.4505 163.963 53.5674 164.954 53.0096C165.946 52.4519 167.193 52.173 168.696 52.173C170.478 52.173 171.918 52.661 173.018 53.6371C174.134 54.5977 174.692 55.8526 174.692 57.4019C174.692 58.6259 174.397 59.6484 173.809 60.4696C173.22 61.2752 172.259 62.1506 170.927 63.0957L168.138 65.0478H174.854V68.7197H161.979Z",
    fill: "#E7B400"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M158.384 66.6048C157.005 68.2315 155.185 69.0449 152.923 69.0449C150.661 69.0449 148.841 68.2393 147.462 66.628C146.098 65.0012 145.417 62.9871 145.417 60.5856C145.417 58.2152 146.114 56.2166 147.508 54.5898C148.902 52.9475 150.723 52.1263 152.969 52.1263C155.231 52.1263 157.044 52.9397 158.408 54.5665C159.786 56.1933 160.476 58.1997 160.476 60.5856C160.476 62.9561 159.779 64.9625 158.384 66.6048ZM150.785 63.816C151.343 64.6371 152.071 65.0477 152.969 65.0477C153.868 65.0477 154.588 64.6371 155.131 63.816C155.673 62.9793 155.944 61.9026 155.944 60.5856C155.944 59.2842 155.658 58.2152 155.084 57.3785C154.527 56.5419 153.806 56.1236 152.923 56.1236C152.024 56.1236 151.304 56.5342 150.762 57.3553C150.219 58.1764 149.948 59.2532 149.948 60.5856C149.948 61.9026 150.227 62.9793 150.785 63.816Z",
    fill: "#E7B400"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M130.729 68.7197V65.3267L136.818 60.6787C137.577 60.1055 138.112 59.602 138.422 59.1682C138.747 58.7189 138.91 58.2463 138.91 57.7505C138.91 57.2393 138.739 56.8364 138.399 56.5421C138.073 56.2477 137.639 56.1005 137.097 56.1005C136.57 56.1005 136.059 56.2632 135.563 56.5885C135.083 56.8984 134.518 57.4329 133.867 58.1921L130.822 55.6589C131.752 54.4505 132.713 53.5674 133.704 53.0096C134.696 52.4519 135.943 52.173 137.446 52.173C139.228 52.173 140.668 52.661 141.768 53.6371C142.884 54.5977 143.442 55.8526 143.442 57.4019C143.442 58.6259 143.147 59.6484 142.559 60.4696C141.97 61.2752 141.009 62.1506 139.677 63.0957L136.888 65.0478H143.604V68.7197H130.729Z",
    fill: "#E7B400"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M146.15 16.2229C145.108 13.255 144.064 10.2814 143.022 7.3077C142.989 7.31153 142.957 7.31535 142.922 7.31918C141.89 10.2852 140.857 13.2493 139.821 16.2229H135.998C134.25 10.9583 132.498 5.68033 130.729 0.350709H135.367C136.256 3.30906 137.155 6.29609 138.054 9.28313C138.086 9.28313 138.117 9.28312 138.149 9.28121C139.144 6.29035 140.138 3.30141 141.134 0.30481H144.925C145.921 3.31097 146.913 6.30374 147.906 9.29651C147.936 9.29269 147.965 9.28695 147.996 9.28313C148.895 6.30565 149.791 3.32818 150.692 0.343058H155.245C153.478 5.66503 151.727 10.9449 149.973 16.2267H146.152L146.15 16.2229Z",
    fill: "#090909"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M167.634 27.389C167.831 27.389 167.977 27.389 168.122 27.389C169.351 27.389 170.583 27.4005 171.813 27.3813C172.134 27.3756 172.31 27.4788 172.478 27.7542C173.539 29.5078 174.622 31.248 175.697 32.9921C175.781 33.1297 175.872 33.2636 176.01 33.472C177.284 31.4354 178.5 29.4275 179.751 27.4157H184.382V43.1139C184.03 43.2229 180.632 43.2478 180.034 43.1369V34.3689C180.001 34.3574 179.969 34.346 179.934 34.3345C179.567 34.7992 179.274 35.3193 178.944 35.8108C178.615 36.3004 178.297 36.7995 177.974 37.2928C177.643 37.8015 177.312 38.3102 176.98 38.817C176.658 39.3065 176.337 39.7961 175.966 40.3621C175.469 39.6737 175.064 39.0082 174.633 38.3618C174.19 37.6925 173.754 37.0175 173.312 36.3463C172.885 35.6942 172.457 35.044 171.969 34.4072C171.904 35.1472 171.91 35.8739 171.908 36.6006C171.908 37.3215 171.908 38.0444 171.908 38.7653V43.1656H167.632V27.3871L167.634 27.389Z",
    fill: "#090909"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M197.168 33.4763C198.44 31.4148 199.67 29.4222 200.907 27.4142H205.466C205.581 27.7661 205.615 42.5368 205.5 43.1679H201.203V34.3273C200.949 34.4018 200.898 34.5892 200.808 34.725C199.683 36.4384 198.566 38.1576 197.446 39.873C197.35 40.0183 197.247 40.1598 197.103 40.3625C195.771 38.3297 194.48 36.3619 193.189 34.3942C193.155 34.398 193.12 34.4018 193.086 34.4057C193.076 34.5701 193.057 34.7327 193.057 34.8971C193.057 37.4558 193.057 40.0145 193.057 42.5731C193.057 42.7644 193.057 42.9537 193.057 43.1698H188.796V27.4257C188.919 27.4123 189.043 27.3875 189.167 27.3875C190.447 27.3836 191.726 27.3951 193.005 27.3779C193.311 27.3741 193.472 27.4926 193.623 27.7412C194.688 29.491 195.769 31.235 196.845 32.9791C196.929 33.1167 197.021 33.2506 197.167 33.4705L197.168 33.4763Z",
    fill: "#090909"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M223.439 6.41105C224.724 4.32854 225.962 2.32443 227.189 0.333715H231.739C231.848 0.691317 231.882 15.4353 231.775 16.0969H227.474V7.18745C227.057 7.5986 226.857 8.02313 226.596 8.40177C226.327 8.79379 226.074 9.1973 225.814 9.59506C225.545 10.0062 225.277 10.4193 225.007 10.8304C224.747 11.2282 224.489 11.6278 224.229 12.0256C223.971 12.4215 223.711 12.8154 223.407 13.2763C222.998 12.758 222.699 12.2398 222.368 11.7464C222.039 11.2569 221.72 10.7597 221.397 10.2663C221.064 9.75951 220.731 9.25084 220.399 8.74407C220.077 8.25643 219.756 7.7688 219.435 7.28115C219.4 7.29072 219.366 7.29836 219.332 7.30792V16.1007H215.079V0.337543C215.234 0.329894 215.362 0.318419 215.49 0.318419C216.754 0.318419 218.016 0.326066 219.28 0.310768C219.582 0.306943 219.748 0.414036 219.901 0.666461C220.94 2.37607 221.994 4.07612 223.043 5.77999C223.154 5.95974 223.269 6.1395 223.441 6.41296L223.439 6.41105Z",
    fill: "#090909"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M179.074 16.0987V0.341204C179.259 0.331643 179.418 0.316343 179.579 0.316343C181.499 0.316343 183.417 0.304871 185.337 0.318257C186.996 0.331644 188.603 0.622318 190.089 1.39681C192.445 2.62451 193.699 4.60949 193.997 7.2198C194.181 8.82041 193.957 10.3617 193.227 11.8113C192.213 13.8268 190.538 15.022 188.417 15.6627C187.356 15.9839 186.266 16.1121 185.164 16.1216C183.262 16.1388 181.359 16.1274 179.456 16.1254C179.343 16.1254 179.232 16.1101 179.074 16.0968V16.0987ZM183.464 12.2951C184.401 12.2626 185.293 12.297 186.165 12.188C188.058 11.9509 189.28 10.7404 189.517 8.87586C189.886 5.96723 188.071 4.42973 185.998 4.23085C185.266 4.16009 184.526 4.18113 183.789 4.16583C183.682 4.16392 183.575 4.19643 183.464 4.21364V12.297V12.2951Z",
    fill: "#090909"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M212.746 7.9198C212.742 12.1345 209.992 15.4907 206.128 16.2441C203.238 16.8082 200.599 16.2345 198.377 14.2438C194.581 10.8456 194.975 4.59046 199.134 1.62446C202.131 -0.511591 206.342 -0.55366 209.344 1.57283C211.624 3.18874 212.672 5.46821 212.744 7.91789L212.746 7.9198ZM208.294 8.35199C208.302 6.8948 207.812 5.77036 206.81 4.88496C205.416 3.65343 203.146 3.64961 201.743 4.84289C199.769 6.51808 199.718 9.93347 201.836 11.6488C203.364 12.8861 205.709 12.7599 207.078 11.3524C207.921 10.4861 208.304 9.43435 208.296 8.3539L208.294 8.35199Z",
    fill: "#090909"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M148.747 27.4159H153.166C153.166 27.632 153.166 27.8232 153.166 28.0144C153.166 30.6381 153.16 33.2637 153.172 35.8874C153.174 36.3598 153.199 36.8436 153.296 37.3044C153.604 38.7826 154.642 39.5916 156.149 39.5265C156.583 39.5074 157.04 39.429 157.436 39.2607C158.412 38.8477 158.817 38.0063 158.939 37.0042C158.974 36.7288 158.972 36.4477 158.974 36.1685C158.976 33.4626 158.974 30.7567 158.974 28.0488V27.479C159.373 27.3681 162.852 27.3508 163.399 27.4522C163.407 27.6186 163.42 27.7926 163.42 27.9685C163.42 30.7414 163.424 33.5123 163.42 36.2852C163.42 37.14 163.326 37.9852 163.108 38.8152C162.523 41.0411 161.106 42.4658 158.918 43.1007C157.069 43.6361 155.191 43.6514 153.332 43.1427C150.837 42.46 149.37 40.8078 148.915 38.2721C148.796 37.6142 148.735 36.9373 148.731 36.268C148.712 33.4473 148.722 30.6247 148.724 27.8041C148.724 27.6912 148.737 27.5784 148.747 27.4159Z",
    fill: "#090909"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M176.518 2.15781C175.776 3.20576 175.059 4.21546 174.334 5.23663C173.944 5.00716 173.6 4.78915 173.242 4.59601C172.294 4.08351 171.286 3.74886 170.2 3.72017C169.844 3.71061 169.475 3.73547 169.131 3.81769C168.639 3.93626 168.347 4.29004 168.335 4.70501C168.322 5.17353 168.572 5.50245 168.993 5.64396C169.72 5.89065 170.464 6.09144 171.2 6.30753C171.986 6.53701 172.781 6.73589 173.554 7.0017C174.015 7.15851 174.456 7.39181 174.883 7.63085C176.529 8.55067 177.095 10.0117 176.919 11.8188C176.742 13.6508 175.745 14.9034 174.114 15.6836C173.091 16.1732 171.997 16.3548 170.871 16.3778C168.45 16.4275 166.186 15.9054 164.147 14.5534C163.902 14.3909 163.673 14.2035 163.44 14.0218C163.35 13.953 163.271 13.8707 163.149 13.7579C163.956 12.796 164.753 11.8475 165.581 10.8627C165.74 10.9736 165.882 11.073 166.023 11.1744C167.54 12.2548 169.211 12.8438 171.091 12.7157C171.393 12.6947 171.714 12.6163 171.98 12.4747C172.655 12.121 172.693 11.2872 172.053 10.876C171.754 10.6848 171.408 10.5471 171.066 10.4496C170.2 10.2029 169.316 10.0136 168.454 9.75926C167.781 9.56038 167.104 9.34429 166.465 9.0517C164.252 8.03626 163.528 6.24251 164.023 3.94964C164.428 2.07175 165.744 0.991299 167.505 0.409956C168.727 0.00645729 169.991 0.00454519 171.255 0.117372C173.053 0.276094 174.715 0.82875 176.187 1.90156C176.279 1.96849 176.367 2.04307 176.514 2.15781H176.518Z",
    fill: "#090909"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M131.45 40.8308C132.27 39.8574 133.071 38.907 133.888 37.9355C134.071 38.0675 134.228 38.1822 134.389 38.2931C135.884 39.3411 137.529 39.9129 139.372 39.7924C139.675 39.7733 139.998 39.6987 140.265 39.561C140.967 39.2015 141.002 38.3563 140.334 37.9355C140.047 37.7539 139.719 37.6219 139.392 37.5301C138.51 37.2815 137.611 37.0865 136.731 36.8283C136.089 36.6409 135.452 36.4172 134.834 36.159C131.199 34.6425 131.694 30.1849 133.892 28.5002C134.833 27.7792 135.879 27.3432 137.037 27.2189C139.25 26.9799 141.394 27.2419 143.388 28.2937C143.876 28.5518 144.329 28.875 144.844 29.1982C144.084 30.2672 143.369 31.2788 142.633 32.3153C142.457 32.2082 142.306 32.1164 142.157 32.0246C141.027 31.3189 139.82 30.8332 138.472 30.793C138.116 30.7835 137.749 30.8198 137.405 30.904C136.974 31.0072 136.676 31.296 136.64 31.7607C136.603 32.2273 136.854 32.5677 137.275 32.7111C138.017 32.9654 138.778 33.1643 139.529 33.39C140.422 33.6577 141.327 33.8967 142.201 34.2161C142.686 34.3939 143.145 34.675 143.578 34.9657C144.995 35.9161 145.375 37.3198 145.216 38.9223C145.031 40.7983 143.973 42.0432 142.302 42.8158C141.596 43.1428 140.845 43.3302 140.076 43.399C137.636 43.617 135.303 43.2499 133.134 42.0528C132.532 41.72 131.968 41.3318 131.448 40.8289L131.45 40.8308Z",
    fill: "#090909"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M218.022 27.4176H231.751C231.866 27.7656 231.898 30.5328 231.787 31.2327H227.1V43.1655H222.727C222.717 39.2147 222.727 35.2696 222.721 31.2633C221.151 31.1982 219.602 31.2671 218.021 31.2231V27.4176H218.022Z",
    fill: "#090909"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M157.102 0.339478H161.402V16.0969H157.102V0.339478Z",
    fill: "#090909"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M214.36 27.4254V43.1236C213.996 43.2192 210.776 43.246 210.097 43.1618C209.994 42.8195 209.95 28.2554 210.055 27.4254H214.36Z",
    fill: "#090909"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1681_235",
    x1: 85.8381,
    y1: 8.1121,
    x2: 64.5649,
    y2: 8.1121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1681_235",
    x1: 64.5649,
    y1: -8.74418,
    x2: 85.8381,
    y2: 8.1121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1681_235",
    x1: 106.513,
    y1: 36.989,
    x2: 96.1393,
    y2: 38.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFFCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFEDAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFE06D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1681_235",
    x1: 77.3124,
    y1: 17.4544,
    x2: 62.9188,
    y2: 15.9409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFDB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1681_235",
    x1: 75.2173,
    y1: 6.33954,
    x2: 71.614,
    y2: 12.5822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1681_235",
    x1: 73.9435,
    y1: 58.3372,
    x2: 78.157,
    y2: 60.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1681_235",
    x1: 77.4668,
    y1: 15.057,
    x2: 85.838,
    y2: 15.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1681_235",
    x1: 80.896,
    y1: 15.057,
    x2: 93.9287,
    y2: 15.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1681_235",
    x1: -8.7587,
    y1: 15.057,
    x2: 99.9196,
    y2: 15.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1681_235",
    x1: 93.5364,
    y1: 4.49917,
    x2: 103.407,
    y2: 14.0303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1681_235",
    x1: 114.349,
    y1: 6.64223,
    x2: 103.823,
    y2: 22.2272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFF3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFE892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFDA52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1681_235",
    x1: 123.435,
    y1: 31.0973,
    x2: 113.139,
    y2: 25.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFFBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFF7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFF1BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFE99A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFE06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1681_235",
    x1: 99.8877,
    y1: 26.3656,
    x2: 120.471,
    y2: 26.3656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1681_235",
    x1: 93.9282,
    y1: 20.5249,
    x2: 99.8876,
    y2: 20.5249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1681_235",
    x1: 99.8877,
    y1: 26.3656,
    x2: 108.01,
    y2: 26.3656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1681_235",
    x1: 94.3765,
    y1: 32.1798,
    x2: 108.01,
    y2: 32.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1681_235",
    x1: 101.941,
    y1: 36.984,
    x2: 120.47,
    y2: 36.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1681_235",
    x1: 101.941,
    y1: 39.9432,
    x2: 120.47,
    y2: 39.9432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1681_235",
    x1: 80.896,
    y1: 38.1634,
    x2: 101.942,
    y2: 38.1634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1681_235",
    x1: 102.84,
    y1: 43.51,
    x2: 101.66,
    y2: 54.5207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFFAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFEEB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFDA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1681_235",
    x1: 95.2021,
    y1: 62.9186,
    x2: 127.072,
    y2: 62.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1681_235",
    x1: 95.2021,
    y1: 51.8886,
    x2: 109.395,
    y2: 51.8886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1681_235",
    x1: 95.2021,
    y1: 58.7995,
    x2: 127.072,
    y2: 58.7995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFDB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1681_235",
    x1: 80.896,
    y1: 57.6568,
    x2: 99.8832,
    y2: 57.6568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1681_235",
    x1: 83.4701,
    y1: 44.1518,
    x2: 80.9977,
    y2: 39.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFE894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1681_235",
    x1: 80.896,
    y1: 39.5485,
    x2: 101.942,
    y2: 39.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1681_235",
    x1: 88.6667,
    y1: 42.033,
    x2: 98.1034,
    y2: 48.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFF1BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFE68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFDA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1681_235",
    x1: 77.4668,
    y1: 18.7863,
    x2: 80.8957,
    y2: 18.7863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1681_235",
    x1: 64.5649,
    y1: 42.5851,
    x2: 80.8957,
    y2: 42.5851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1681_235",
    x1: 84.8307,
    y1: -0.0896274,
    x2: 85.0487,
    y2: 12.4854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFDB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1681_235",
    x1: 0,
    y1: 34.6013,
    x2: 13.4831,
    y2: 34.6013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1681_235",
    x1: 11.5265,
    y1: 3.82118,
    x2: 11.9769,
    y2: 15.1685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFE791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDA52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1681_235",
    x1: 17.9337,
    y1: 14.827,
    x2: 25.4283,
    y2: 17.2631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1681_235",
    x1: 9.66191,
    y1: 72.7186,
    x2: 23.9102,
    y2: 33.5697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1681_235",
    x1: 24.2176,
    y1: 45.9655,
    x2: 13.0567,
    y2: 52.4092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1681_235",
    x1: 22.6799,
    y1: 43.3381,
    x2: 37.4585,
    y2: 30.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1681_235",
    x1: 28.0872,
    y1: 34.6329,
    x2: 31.1213,
    y2: 19.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1681_235",
    x1: 47.936,
    y1: 38.1536,
    x2: 30.8618,
    y2: 38.1536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1681_235",
    x1: 47.8997,
    y1: 28.3974,
    x2: 44.0809,
    y2: 32.9475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1681_235",
    x1: 44.0059,
    y1: 37.5411,
    x2: 51.0356,
    y2: 37.5411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1681_235",
    x1: 41.1439,
    y1: 19.7718,
    x2: 52.0747,
    y2: 13.4613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1681_235",
    x1: 54.5834,
    y1: 2.11639,
    x2: 55.0338,
    y2: 13.4637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFEEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1681_235",
    x1: 41.7178,
    y1: 55.2835,
    x2: 47.3696,
    y2: 56.5887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1681_235",
    x1: 54.5107,
    y1: 66.9578,
    x2: 54.5107,
    y2: 50.2081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFFAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FFEFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1681_235",
    x1: 64.5652,
    y1: 34.7368,
    x2: 51.0361,
    y2: 34.7368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B97E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C69637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D2AD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#DDC087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E6D1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F4EBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F9F4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1681_235",
    x1: 64.5649,
    y1: 34.7368,
    x2: 78.0529,
    y2: 34.7368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrwsLogo);
export default __webpack_public_path__ + "static/media/hrws_logo.50636e14bf312d091a11993ab81e662e.svg";
export { ForwardRef as ReactComponent };